import { APIError } from '../api/errors';

export const URL_PREFIX = '/api/amplify';

export const MAX_RETRY_COUNT = 1;
export const RETRY_DELAY = 1000; // 1s

export const retryOn504Options = {
  retry: (failureCount: number, error: unknown) => {
    const is504 = error instanceof APIError && error.status === 504;

    if (failureCount < MAX_RETRY_COUNT && is504) {
      return true;
    }

    return false;
  },
  retryDelay: RETRY_DELAY,
};
